import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Spinner.module.scss'

interface ISpinnerProps {
  // A carousel or banner row is shorter than a page of results.
  row?: boolean
}

// Kroger's loader: a short blue arc turning on a pale track, centred in the block it stands in for.
const Spinner = ({ row = false }: ISpinnerProps) => {
  const { t } = useSurveyLocale()

  return (
    <div
      className={`${style.box} ${row ? style.row : ''}`}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-Spinner"
    >
      <svg className={style.ring} viewBox="0 0 48 48" aria-hidden="true">
        <circle className={style.track} cx="24" cy="24" r="22" />
        <circle className={style.arc} cx="24" cy="24" r="22" pathLength="100" />
      </svg>
    </div>
  )
}

export default Spinner
